import ListingType from './listing-type';
var MSiteListingTypeMap = {
  [ListingType.RENTAL_RESIDENTIAL.name]: {
    mode: 'rent',
    context: 'residential'
  },
  [ListingType.SALES_RESIDENTIAL.name]: {
    mode: 'buy',
    context: 'residential'
  },
  [ListingType.RENTAL_COMMERCIAL.name]: {
    mode: 'rent',
    context: 'commercial'
  },
  [ListingType.SALES_COMMERCIAL.name]: {
    mode: 'buy',
    context: 'commercial'
  },
  [ListingType.SALES_BUSINESS.name]: {
    mode: 'buy',
    context: 'business'
  },
  [ListingType.SHARE_RESIDENTIAL.name]: {
    mode: 'share',
    context: 'residential'
  },
  [ListingType.DEVELOPMENTS_RESIDENTIAL.name]: {
    mode: 'newdev',
    context: 'residential'
  }
};
export default MSiteListingTypeMap;